import React, { createRef, useEffect } from "react"
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock"
import * as S from "../elements"

export type WidthVariant = "regular" | "wide"

interface Props {
  isOpen: boolean
  header: React.ReactElement
  footer?: React.ReactElement
  variant?: WidthVariant
  handleClose: () => void
}

export const Sidebar: React.FC<Props> = ({
  header,
  footer,
  isOpen,
  variant = "regular",
  children,
  handleClose,
}) => {
  const ref = createRef<HTMLDivElement>()

  useEffect(() => {
    if (ref && ref.current) {
      disableBodyScroll(ref.current)
    }
  }, [ref])

  useEffect(() => {
    if (isOpen && ref && ref.current) {
      disableBodyScroll(ref.current)
    } else if (ref && ref.current) {
      enableBodyScroll(ref.current)
    }
  }, [isOpen, ref])

  return (
    <>
      <S.Sidebar variant={variant} open={isOpen}>
        <S.Header>{header}</S.Header>
        <S.Content ref={ref}>{children}</S.Content>
        {footer && <S.Footer>{footer}</S.Footer>}
      </S.Sidebar>

      <S.Overlay
        show={isOpen}
        onTouchMove={handleClose}
        onClick={handleClose}
      />
    </>
  )
}
